import { lookupDXCC } from './dxccLookup.js';
import { gridToLatLon, latLonToGrid, isValidGrid } from './gridLocator.js';
import { getEntityCoords } from '../data/entityCoords.js';

// ADIF Parser (.adi, .adif)
export function parseADIF(text) {
  var qsos = [];
  var hdrEnd = text.search(/<eoh>/i);
  var body = hdrEnd >= 0 ? text.substring(hdrEnd + 5) : text;
  var records = body.split(/<eor>/i);
  for (var r = 0; r < records.length; r++) {
    var rec = records[r];
    if (!rec.trim()) continue;
    var fields = {};
    var re = /<(\w+):(\d+)(?::[^>])?>/gi;
    var m;
    while ((m = re.exec(rec)) !== null) {
      fields[m[1].toUpperCase()] = rec.substring(
        m.index + m[0].length,
        m.index + m[0].length + parseInt(m[2])
      ).trim();
    }
    if (!fields.CALL) continue;
    var dxcc = lookupDXCC(fields.CALL);
    var rawGrid = (fields.GRIDSQUARE || fields.GRID || "").trim();
    var gridProvided = !!rawGrid;
    // Drop malformed grids (keep the QSO): a provided-but-invalid grid is discarded,
    // not "corrected" into an invented one. The map still plots via the DXCC centroid.
    var grid = isValidGrid(rawGrid) ? rawGrid : "";
    var coords = gridToLatLon(grid);
    if (!coords && dxcc.entity) { coords = getEntityCoords(dxcc.entity); }
    // Only synthesise a grid when the log provided none at all; never fabricate a
    // replacement for an invalid one.
    if (!grid && !gridProvided && coords) { grid = latLonToGrid(coords.lat, coords.lon); }
    qsos.push({
      call: fields.CALL,
      band: (fields.BAND || "").toLowerCase(),
      mode: fields.MODE || "",
      submode: fields.SUBMODE || "",
      date: fields.QSO_DATE || "",
      time: fields.TIME_ON || fields.TIME_OFF || "",
      grid: grid,
      lat: coords ? coords.lat : null,
      lon: coords ? coords.lon : null,
      freq: fields.FREQ || "",
      rstSent: fields.RST_SENT || fields.RST_SNT || "",
      rstRcvd: fields.RST_RCVD || "",
      entity: dxcc.entity,
      continent: dxcc.cont,
      cq: dxcc.cq,
      itu: dxcc.itu,
      distance: null
    });
  }
  return qsos;
}

// Cabrillo Parser (.log, .cbr)
export function parseCabrillo(text) {
  var qsos = [];
  var lines = text.split("\n");
  for (var li = 0; li < lines.length; li++) {
    var line = lines[li];
    if (!line.startsWith("QSO:")) continue;
    var p = line.substring(4).trim().split(/\s+/);
    if (p.length < 8) continue;
    var f = parseFloat(p[0]);
    var bandStr = "";
    if (f >= 1800 && f <= 2000) bandStr = "160m";
    else if (f >= 3500 && f <= 4000) bandStr = "80m";
    else if (f >= 5000 && f <= 5500) bandStr = "60m";
    else if (f >= 7000 && f <= 7300) bandStr = "40m";
    else if (f >= 10100 && f <= 10150) bandStr = "30m";
    else if (f >= 14000 && f <= 14350) bandStr = "20m";
    else if (f >= 18068 && f <= 18168) bandStr = "17m";
    else if (f >= 21000 && f <= 21450) bandStr = "15m";
    else if (f >= 24890 && f <= 24990) bandStr = "12m";
    else if (f >= 28000 && f <= 29700) bandStr = "10m";
    else if (f >= 50000 && f <= 54000) bandStr = "6m";
    else if (f >= 144000 && f <= 148000) bandStr = "2m";
    else if (f >= 420000 && f <= 450000) bandStr = "70cm";
    var callRcvd = p.length > 7 ? p[7] : "";
    if (!callRcvd) continue;
    var dxcc = lookupDXCC(callRcvd);
    var cabCoords = getEntityCoords(dxcc.entity);
    qsos.push({
      call: callRcvd,
      band: bandStr,
      mode: ({"PH":"SSB","CW":"CW","RY":"RTTY","FM":"FM","DG":"FT8"}[p[1]] || p[1]),
      submode: "",
      date: (p[2] || "").replace(/-/g, ""),
      time: p[3] || "",
      grid: cabCoords ? latLonToGrid(cabCoords.lat, cabCoords.lon) : "",
      lat: cabCoords ? cabCoords.lat : null,
      lon: cabCoords ? cabCoords.lon : null,
      freq: (f / 1000).toFixed(4),
      rstSent: p[5] || "",
      rstRcvd: p.length > 8 ? p[8] : "",
      entity: dxcc.entity,
      continent: dxcc.cont,
      cq: dxcc.cq,
      itu: dxcc.itu,
      distance: null
    });
  }
  return qsos;
}
